import { create } from 'zustand';

// ─── Theme ─────────────────────────────────────────────────────────────────────
const THEME_KEY = 'algosys-theme';

function getInitialTheme() {
  const saved = localStorage.getItem(THEME_KEY);
  if (saved === 'light' || saved === 'dark') return saved;
  return 'dark';
}

function applyTheme(theme) {
  document.documentElement.setAttribute('data-theme', theme);
  localStorage.setItem(THEME_KEY, theme);
}

// Apply before first React render — eliminates theme flash
const _initialTheme = getInitialTheme();
applyTheme(_initialTheme);

// ─── UI Store ──────────────────────────────────────────────────────────────────
export const useUIStore = create((set) => ({
  sidebarCollapsed: false,
  toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),

  toasts: [],
  addToast: (t)  => set((s) => ({ toasts: [...s.toasts, { id: Date.now(), ...t }] })),
  removeToast:(id)=> set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),

  theme: _initialTheme,
  toggleTheme: () =>
    set((s) => {
      const next = s.theme === 'dark' ? 'light' : 'dark';
      applyTheme(next);
      return { theme: next };
    }),
}));

// ─── Toast helper ──────────────────────────────────────────────────────────────
export const toast = {
  success: (message) => useUIStore.getState().addToast({ type: 'success', message }),
  error:   (message) => useUIStore.getState().addToast({ type: 'error',   message }),
  warn:    (message) => useUIStore.getState().addToast({ type: 'warn',    message }),
  info:    (message) => useUIStore.getState().addToast({ type: 'info',    message }),
};

// ─── Re-export session store for backwards compat ─────────────────────────────
export { useSessionStore } from '../session/store';
// Legacy alias so any existing code using useAuthStore still works
export { useSessionStore as useAuthStore } from '../session/store';
